/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 * 
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

function toggleContent(div){  
  var el = div.getElementsByClassName("content-absolute")[0];
  var icon = div.querySelector('svg');

  if(el.classList.contains('show')){
    el.classList.remove('show');
    el.classList.add('hide');
    icon.setAttribute('data-style', 'plus');
    
  } else {
    el.classList.remove('hide');
    el.classList.add('show');   
    icon.setAttribute('data-style', 'minus');
  }
}

function toggleRandom(div){  
  
  var content = div.nextElementSibling;
  var icon = div.querySelector('svg');
  
  if(content.classList.contains('show')){
    content.classList.remove('show');
    content.classList.add('hide');
    icon.setAttribute('data-style', 'plus');
  } else {
    content.classList.remove('hide');
    content.classList.add('show');   
    icon.setAttribute('data-style', 'minus');
  }
}

$(document).ready(function(){
  $('.scrollable_logos').slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });
  
    $('.scrollable_news').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 4,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });
  
  if (window.matchMedia("(max-width: 1007px)").matches) {
    /* the viewport is less than 768 pixels wide */
    $('.reviews_scroll').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 4,
    autoplay: true,
    autoplaySpeed: 6000,
    responsive: [
      {
        breakpoint: 1007,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });
  } 
  
});



function addItemToCart(variant_id) {
  var variants = true;
  data = {
    "id": variant_id,
    "quantity": 2
  }

  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: function() { 
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true  //this code is for prestige theme, is to refresh the cart
      }));
    }
  });
}

function addAllItems(variantIdArray) {
  var newVariantIdArray = variantIdArray;

  var product_data = newVariantIdArray.map(variantId => {
    return {quantity: 1, id: variantId}
  })

  var data = {
    items: product_data
  }
        
  fetch('/cart/add.js', {
    body: JSON.stringify(data),
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With':'xmlhttprequest'
    },
    method: 'POST'
  }).then((response) => {
    return response.json();
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true
    }));
  }).then((json) => {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true
    }));
  }).catch((err) => {
    console.error(err)
  });
}

function addItemToCart2() {
  const products = location.search.substr(1).split("&");
  var productsList = [];
  for (var index = 0; index < products.length; index++) {
    var product = products[index].split("=");
    if (product.length > 1) {
      productsList.push(products[index].split("=")[1]);
    } else {
      addItemToCart(product[1]);
    }
  }
  if (product.length > 1) {
    addAllItems(productsList);
  }
  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
    bubbles: true
  }));
}

/* search */

/* Search text dynamic */
const words = [  
  "GoPrimal Strength & Immunity D3   ",
  "The Beauty Pack   ",
  "GoPrimal Focus & Power. The Primal Nootropic   ",
  "HydraForce - Electrolytes, Creatine and Vit. C   "
];

let cont = 0;
let timer;

function typingEffect() {
  let word = words[cont].split("");
  var loopTyping = function() {
    if (word.length > 0) {
      let elem = document.getElementById('Search__Input');
      elem.setAttribute('placeholder', elem.getAttribute('placeholder') + word.shift());
    } else {
      deletingEffect();
      return false;
    };
    timer = setTimeout(loopTyping, 120);
  };
  loopTyping();
};
function deletingEffect() {
  let word = words[cont].split("");
  var loopDeleting = function() {
    if (word.length > 0) {
      word.pop();
      document.getElementById('Search__Input').setAttribute('placeholder', word.join(""));
    } else {
      if (words.length > (cont + 1)) {
        cont++;
      } else {
        cont = 0;
      };
      typingEffect();
      return false;
    };
    timer = setTimeout(loopDeleting, 100);
  };
  loopDeleting();
};

typingEffect();



function toggleLogin(){
  if ( window.innerWidth > 640 ){
    if (document.querySelector("#login-popup.hide")) {
      document.getElementById("login-popup").className = "show";
    } else {
      document.getElementById("login-popup").className = "hide";
    }
  } else {
    window.location.href = "/account";
  }
}


function addQuick(product_id, variant_id, variants) {
  data = {
    "id": variant_id,
    "quantity": 1
  }

  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: function() { 
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true  //this code is for prestige theme, is to refresh the cart
      }));
      if(variants == true ){
        var element = document.getElementById('sizes_' + product_id);
        element.classList.add("hidden-tablet-and-up");
        element.classList.add("hidden-phone");
        element.classList.remove("Sizes");
      }
    }
  });
  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
    bubbles: true    // same code for prestige theme   
  }));
}

$( document ).ready(function() {

  jQuery('.SizeSwatch__Radio').on('change', function(){
      setTimeout(function(){
          jQuery('.ProductForm__AddToCart').children().html('<span class="Heading text-white">Add to cart</span>');
          console.log('changed');
      }, 150);
  });

  
  var m_multi_line_text = $('.template-product .SectionHeader__Description .metafield-multi_line_text_field');
  $( m_multi_line_text ).each(function( index ) {
    var htmlString = $( this ).html().replace(eval("/&lt;/g"), "<").replace(eval("/&gt;/g"), ">");
    $( this ).parent().parent().html( htmlString );
  });
});


